var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 19.34,
  height: 25.34,
  "data-name": "Layer 1",
  viewBox: "0 0 19.34 25.34"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeWidth: 2.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.54 7.36a8.25 8.25 0 1 1 .82 6.25 8.13 8.13 0 0 1-.82-6.25Z"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  d: "m13.73 16.74 4.36 7.35"
}))));
export default SvgSearch;